__turbopack_context__.v({
  "wrapper": "styles-module__-0Qtpa__wrapper",
});
